import React from "react";
import { Card } from "@ui/card";
import { ReaderPlanItem } from "@modules/local/db";
import TranslatedText from "@components/items/display/TranslatedText";

const SubscriptionHistoryTab = ({
  currentPlan,
}: {
  currentPlan: ReaderPlanItem | null;
}) => {
  return (
    <div className="flex w-full items-center justify-center p-5">
      <Card className="flex flex-col items-center justify-center gap-5 border-none bg-[#D9D9D9]/15 p-8">
        <TranslatedText
          text={`settings.titles.${"wajeez premium subscription"}`}
          className="text-[15px]"
        />
        <div className="relative w-full">
          <div
            className="relative mx-auto flex flex-col items-center justify-center gap-1 rounded-lg bg-cover"
            style={{
              backgroundImage: "url('/assets/images/sub-bg.png')",
              width: "281px",
              height: "171px",
            }}
          >
            <div className="mt-5 text-[25px] font-medium text-white">
              {currentPlan?.planName}
            </div>
            <div className="text-[13px] font-medium text-white opacity-70">
              {currentPlan?.name}
            </div>
            <div className="absolute bottom-4 start-4 flex flex-col items-center justify-center text-[12px] font-medium text-white opacity-70">
              <TranslatedText text={`settings.titles.${"activated until"}`} />
              <div>{currentPlan?.expiration?.split("T")[0]}</div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SubscriptionHistoryTab;
